export default function msToTime(duration) {
  const hours = Math.floor(duration / 3_600_000);
  const minutes = Math.floor((duration % 3_600_000) / 60_000);
  const seconds = Math.floor((duration % 60_000) / 1000);
  const milliseconds = duration % 1000;
  const msStr = String(milliseconds).padStart(3, "0");

  if (hours > 0) {
    const h = String(hours);
    const m = String(minutes).padStart(2, "0");
    const s = String(seconds).padStart(2, "0");
    return `${h}:${m}:${s}.${msStr}`;
  }
  if (minutes > 0) {
    const m = String(minutes);
    const s = String(seconds).padStart(2, "0");
    return `${m}:${s}.${msStr}`;
  }
  // only seconds (no padding) + milliseconds
  return `${seconds}.${msStr}`;
}
